import { useCallback } from 'react';

import { useLocation } from 'react-router-dom';

import { useLocale } from '../context';
import { defaultLocale, Language } from '../entities/Locale/Locale';
import { isSSR } from '../helpers';
import { getTranslation, TranslatorFunction } from '../helpers/trans';

export const useTrans = (): TranslatorFunction => {
    const { language } = useLocale();
    const { pathname } = useLocation();

    return useCallback<TranslatorFunction>((...args) => {
        if (!isSSR) {
            return getTranslation(language, ...args);
        }

        const routeLanguage = pathname
            ? pathname.split('/')[1] as Language
            : defaultLocale.language;

        const ssrLanguage = Object.values(Language).includes(routeLanguage)
            ? routeLanguage
            : defaultLocale.language;

        return getTranslation(ssrLanguage, ...args);
    }, [language]);
};
